import { render, staticRenderFns } from "./LevelsSelection.vue?vue&type=template&id=58bbf5f2&scoped=true&"
import script from "./LevelsSelection.vue?vue&type=script&lang=js&"
export * from "./LevelsSelection.vue?vue&type=script&lang=js&"
import style0 from "./LevelsSelection.vue?vue&type=style&index=0&id=58bbf5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bbf5f2",
  null
  
)

export default component.exports